module.exports = __webpack_public_path__ + "static/media/dots2.6b4971ef.png";